import LandingPage from './LandingPage'

const ConcreteLanding = () => (
  <LandingPage
    image="/landings/concrete-landing.jpg"
    alt="Luxury Concrete and Turf Design — Low Maintenance, High Impact"
    formUrl="/landing-concrete-form"
    title="Concrete Services"
    headline="Luxury Concrete & Turf Design."
    subtitle="Low maintenance, high impact. We design and build driveways, patios, and outdoor surfaces tailored to South Florida conditions — durable, code-compliant, and built to last."
    features={['Driveways', 'Patios', 'Concrete Slabs', 'Turf Integration']}
    cta="GET YOUR CONCRETE/TURF QUOTE NOW!"
  />
)

export default ConcreteLanding
